import { render } from "./MainComponent.vue?vue&type=template&id=16c1be1e&scoped=true"
import script from "./MainComponent.vue?vue&type=script&lang=js"
export * from "./MainComponent.vue?vue&type=script&lang=js"

import "./MainComponent.vue?vue&type=style&index=0&id=16c1be1e&scoped=true&lang=css"

import exportComponent from "/Users/konradmilewski/Projects/AppWorks/janpawelvue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c1be1e"]])

export default __exports__